import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialogService } from '@serviceplan/ui-kit';
import { NotificationService } from '@thehubz/client/core';
import { UpdateUserDto, User, UsersApiService, Vacation } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { Observable } from 'rxjs';
import { UserVacationDialogComponent } from './user-vacations/user-vacation-dialog/user-vacation-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  constructor(
    private dialog: MatDialog,
    private userService: UsersApiService,
    private readonly notify: NotificationService,
    private readonly confirmDialog: ConfirmDialogService,
  ) {}

  openVacationDialog(loginUserID: string, vacations: Vacation[], userData: User, vacation?: Vacation, index?: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.data = { vacation, user: userData, vacations: vacations, index };
    dialogConfig.width = '60%';
    dialogConfig.disableClose = true;
    const vacationDialogRef = this.dialog.open(UserVacationDialogComponent, dialogConfig);
    vacationDialogRef.afterClosed().subscribe((result) => {
      if (result && result.data.title && result.data.from && result.data.to) {
        if (result.newData) {
          const newVacation = userData.profile.vacations ? userData.profile.vacations.concat([result.data]) : [result.data];
          const userObject: UpdateUserDto = {
            profile: {
              vacations: newVacation,
            },
          };
          this.updateUser(loginUserID, userObject, 'vacation').subscribe((response) => {
            if (response) {
              this.notify.addNotification({ type: 'success', message: $localize`Vacations added` });
            }
          });
          vacations.push(result.data);
        } else {
          if (vacation?.title || vacation?.from || vacation?.to || vacation?.startTime || vacation?.endTime) {
            vacation.title = result.data.title;
            vacation.from = result.data.from;
            vacation.to = result.data.to;
            vacation.message = result.data.message;
            if (result.data.startTime) {
              vacation.startTime = result.data.startTime;
            } else {
              delete vacation.startTime;
            }

            if (result.data.endTime) {
              vacation.endTime = result.data.endTime;
            } else {
              delete vacation.endTime;
            }

            if (result.data.recurrence) {
              vacation.recurrence = result.data.recurrence;
            } else {
              delete vacation.recurrence;
            }
          }

          userData.profile.vacations = vacations;
          this.updateUser(loginUserID, userData as AnyType, 'vacation').subscribe((response) => {
            if (response) {
              this.notify.addNotification({ type: 'success', message: $localize`Vacations updated` });
            }
          });
        }
      }
    });
  }

  deleteVacation(index: number, loginUserID: string, vacations: Vacation[], userData: User) {
    this.confirmDialog.open({ title: $localize`Delete vacation`, message: $localize`Are you sure you want to delete the vacation?` }).subscribe((delVac) => {
      if (delVac) {
        vacations.splice(index, 1);
        userData.profile.vacations = vacations;
        this.updateUser(loginUserID, userData as AnyType).subscribe((response) => {
          if (response) {
            this.notify.addNotification({ type: 'success', message: $localize`Deleted vacation` });
          }
        });
      }
    });
  }

  calculateHoursPerWeek(hoursPerWeekForm: UntypedFormGroup): number {
    let hoursPerWeek = 0;
    Object.keys(hoursPerWeekForm.controls).forEach((key: string) => {
      const abstractControl = hoursPerWeekForm.get(key);
      if (abstractControl?.value !== undefined) {
        hoursPerWeek += abstractControl?.value;
      }
    });
    return hoursPerWeek;
  }

  updateUser(id: string, userObject: UpdateUserDto, userUpdateState?: string): Observable<User> {
    return this.userService.usersControllerUpdateOwnProfile(id, userObject, userUpdateState);
  }
}
